import React, { Component } from 'react';
import InputDropdownDre from './InputDropdownDre';
import { Form } from 'informed';
import axios from 'axios';
import { API_HOST } from '../../consts';
import InputSelect from '../../components/inputs/InputSelect';
import { toast } from 'react-toastify';

class FiltersPageSelfStudent extends Component {
  handleFilterChange = (filters) => {
    this.props.onFilterChange(filters);
  };

  state = {
    loading: false,
    disciplinaOptions: [],
    disciplinaAtual: null,
    integracaoPayload: null,
    dsiciplinaCurrent: null,
    DisciplinaID: null
  };

  disciplinaData = (d) => ({ value: d.id, label: d.disciplina, ...d });

  fetchDisciplinas = () => {
    axios
      .get(`${API_HOST}/avalia/disciplina`)
      .then((res) => {
        const data = res.data.results.map(this.disciplinaData);
        this.setState({
          disciplinaOptions: data
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  fetchIdn = (idDisciplina) => {
    if (idDisciplina) {
      axios
        .get(
          `${API_HOST}/avalia/estudante?prova_a_cd_disciplina=${idDisciplina}&id=70329`
        )
        .then((res) => {
          this.setState({
            idn: res.data.results[0].idn
          });
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  componentDidMount() {
    this.fetchDisciplinas();
  }

  render() {
    const { idn, disciplinaOptions, currentStudent } = this.state;
    const { history } = this.props;
    return (
      <>
        <div style={{ marginTop: '5rem', background: '#fff' }}>
          <div className="container mb-4 pb-4">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h1>Relatório individual do Estudante - nota e proficiência</h1>
                    <hr />
                  </div>
                  <div className="card-body">
                    <Form
                      getApi={(formApi) => {
                        this.formApi = formApi;
                      }}
                    >
                      {({ formState }) => <div className="row"></div>}
                      <div className="row">
                        <div className="input-type-style">
                          <label
                            htmlFor="Disciplina"
                            className="input-label-style"
                            style={{ marginBottom: '1rem' }}
                          >
                            <span className="filter-label">Componente Curricular/Área do Conhecimento</span>
                          </label>
                          <InputSelect
                            label=""
                            col="col-md-12"
                            field="disciplinaOptions"
                            onChange={(e) => {
                              if (e) {
                                this.fetchIdn(e.id);
                              }
                            }}
                            options={disciplinaOptions}
                          />
                        </div>

                        <button
                          style={{
                            color: 'white',
                            backgroundColor: 'rgb(103, 53, 221)',
                            border: '1px solid rgba(58, 58, 58, 0.25)',
                            fontSize: '12pt',
                            textAlign: 'center',
                            cursor: 'pointer',
                            borderRadius: '8px',
                            boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                            letterSpacing: '1px',
                            padding: '4px 16px',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center'
                          }}
                          onClick={() => {
                            idn
                              ? history.push(`/relatorio-meu/${idn}`)
                              : toast.error(
                                  'Os campos não foram preenchidos corretamente. Por favor selecione alguma opção.'
                                );
                          }}
                        >
                          Buscar
                        </button>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default FiltersPageSelfStudent;
